import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= TAMIL NADU CITY DATA ================= */

const tamilNaduCities = [
  { slug: "chennai", city: "Chennai", state: "Tamil Nadu" },
  { slug: "coimbatore", city: "Coimbatore", state: "Tamil Nadu" },
  { slug: "madurai", city: "Madurai", state: "Tamil Nadu" },
  { slug: "trichy", city: "Trichy", state: "Tamil Nadu" },
  { slug: "salem", city: "Salem", state: "Tamil Nadu" }
];

const TamilNadu = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <div style={{ marginTop: "90px", padding: "25px", lineHeight: "1.8" }}>
        <h1>Sex Toys Delivery in Tamil Nadu</h1>

        <p>
          Buy premium <strong>sex toys in Tamil Nadu</strong> with fast & discreet
          delivery. LushDesire is a trusted Indian adult wellness store offering
          genuine products for men, women, and couples.
        </p>

        <h2>Cities We Serve in Tamil Nadu</h2>

        <ul>
          {tamilNaduCities.map((c) => (
            <li key={c.slug}>
              <Link to={`/sex-toys-delivery/tamil-nadu/${c.slug}`}>
                Sex Toys in {c.city}
              </Link>
            </li>
          ))}
        </ul>

        <h3>Why Buy Sex Toys Online from LushDesire?</h3>
        <p>
          We focus on privacy, product quality, and fast delivery. All orders are
          packed discreetly and delivered safely across Tamil Nadu.
        </p>
      </div>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = tamilNaduCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{  backgroundColor: "#FFF5F5", marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Tamil Nadu
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys & couples wellness products available across Tamil Nadu.`}
        />
      </Helmet>
      <CategorySlider />


      <div style={{   backgroundColor: "#FFF5F5", padding: "25px", lineHeight: "1.8" }}>
        {/* H1 */}
        <h1>Sex Toys in {cityData.city} – 100% Discreet Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium, body-safe adult toys with complete privacy and fast
          delivery across Tamil Nadu.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Buying sex toys online in {cityData.city} is now safe and convenient.
          Our collection includes pleasure and wellness products designed to
          enhance intimacy and confidence.
        </p>

        {/* H3 */}
        <h3>Popular Sex Toys Available in {cityData.city}</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet & Plain Packaging</li>
          <li>✔ Fast Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Secure Online Payments</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery Across Tamil Nadu</h4>
        <p>
          All orders are shipped in plain packaging with no adult branding. We
          deliver safely across {cityData.city}, Chennai, Coimbatore, Madurai,
          Trichy, Salem, and nearby areas.
        </p>

        {/* H4 */}
        <h4>Who Can Buy Sex Toys from LushDesire?</h4>
        <p>
          Our products are suitable for beginners as well as experienced users.
          Whether shopping solo or as a couple, we provide safe and reliable
          options for everyone.
        </p>

        {/* H5 */}
        <h5>Frequently Asked Questions</h5>
        <p>
          <strong>Is delivery discreet?</strong> Yes, all orders are packed
          privately.<br />
          <strong>Is COD available?</strong> Yes, Cash on Delivery is available
          in most locations of {cityData.city}.<br />
          <strong>Are products genuine?</strong> Yes, we sell only original,
          body-safe products.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Order today from LushDesire and enjoy premium adult wellness products
          with fast delivery, complete privacy, and trusted service.
        </p>

        <p>
          <strong>LushDesire</strong> – Trusted Online Sex Toy Store in Tamil Nadu.
        </p>
      </div>
    </>
  );
};

export default TamilNadu;
